import { USER_ROLES_LABELS } from 'shared/consts'

const getRoleLabel = role => USER_ROLES_LABELS[role]

export default getRoleLabel
